import { useState, useEffect, useContext } from "react";
import { UserContext } from "@src/App";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  setData,
  setEndPage,
  setInPath,
  setIsComplete,
  setOrigin,
  setPartnerUuids,
} from "@src/@slice/bookingHallSlice";
import { duplicateReservation, getReservation } from "./../../../api/booking/booking";
import useUrlQueryString from "../../../utils/hooks/useUrlQueryString";
import Modal from "@src/components/common/modal/Modal";
import dayjs from "dayjs";
import { HOSTNAME, isExternalUrl } from "@src/utils";

const timeList = ["오전", "점심", "오후", "저녁"];
const Index = () => {
  const navigate = useNavigate();
  const location = useLocation(); // 현재 URL 정보를 가져옴
  const user = useContext(UserContext);
  const dispatch = useDispatch();
  const query = useUrlQueryString();
  const partnerUuids = query.get("partnerUuids");
  const partnerId = query.get("partnerId");
  const origin = query.get("origin");
  const inpath = query.get("inpath");
  const [isDuplicate, setIsDuplicate] = useState(false);

  useEffect(() => {
    // init
    const uuidArr = partnerUuids ? partnerUuids.split(",") : [];
    if (user.me === null && !user.updated) return;
    setEndPage({ page: "customer-info" }); // localStorage에 endPage가 visit-date로 저장 된 사람들이 혹시 있을 수 있으니 넣어두자.
    dispatch(setIsComplete({ bool: false }));
    if (user.me) {
      (async () => {
        let item: any = null;

        //우선 중복체크 주석처리
        // if (uuidArr.length === 1) {
        //   const { data } = await duplicateReservation(partnerUuids, user.me.uuid);
        //   // console.log(data.result);
        //   if (data.result === 409) {
        //     setIsDuplicate(true);
        //     return;
        //   }
        // }
        getReservation(user.me.uuid)
          .then((res) => {
            const obj = res.data.item;
            item = res.data.item;
            if (obj !== null) {
              delete obj.uuid;
              delete obj.regTsp;
              delete obj.id;
              obj.hopeVisit = {
                additionalInquiry: "",
                dates: obj.hopeVisit.dates.filter(date => dayjs(date.date).add(1, 'day').isAfter(dayjs())),
              };
							// 이미 지난 년월은 제거해서 보여줘야함
							obj.hopeWedding.yearMonths = obj.hopeWedding.yearMonths.filter(yearMonth => dayjs(yearMonth.replace(/[^0-9]/g, '')).endOf('month').isAfter(dayjs()));
							// 과거 다른 문자열을 사용한 사례가 안보이게 timeList에 있는 문자열만 남김
							obj.hopeWedding.times = obj.hopeWedding.times.filter(time => timeList.includes(time));
              obj.partnerUuids = [];
              if (partnerUuids) {
                obj.partnerUuids = partnerUuids?.split(",");
              }
              dispatch(setData({ data: obj }));
            } else {
              if (partnerUuids) {
                dispatch(setPartnerUuids({ uuid: partnerUuids.split(",") }));
              }
            }
          })
          .finally(() => {
            if (inpath) {
              dispatch(setInPath({ inpath: inpath }));
            }
            if (origin) {
              dispatch(setOrigin({ origin: origin.substring(0, 10) }));
            }
            if (partnerUuids) {
              if (!inpath) {
                dispatch(setInPath({ inpath: "VISIT" }));
              }
              // if (item) {
              //   dispatch(setEndPage({ page: "visit-date" }));
              //   navigate("/booking/hall/customer-info", { replace: true });
              // } else {
              //   navigate("/booking/hall/hope-date", { replace: true });
              // }
              // navigate("/booking/hall/hope-date", { replace: true }); // 즉시/일반 예약 통합하면서 방문 시 추가 문의 내용으로 리다이렉트
              //booking/hall?partnerId=${partnerId}&partnerUuids=${partnerUuids}&hidetop=false
              // navigate("/booking/hall/visit-date/additional/1", { replace: true });
              navigate(`/booking/hall/date?partnerId=${partnerId}&partnerUuid=${partnerUuids}&hidetop=true`, { replace: true });
            } else {
              navigate("/booking/hall/select", { replace: true });
            }
          });
      })();
    } else {
      if (inpath) {
        dispatch(setInPath({ inpath: inpath }));
      }
      if (origin) {
        dispatch(setOrigin({ origin: origin.substring(0, 10) }));
      }
      if (partnerUuids) {
        if (!inpath) {
          dispatch(setInPath({ inpath: "VISIT" }));
        }
        dispatch(setPartnerUuids({ uuid: partnerUuids.split(",") }));
        navigate("/booking/hall/hope-date?hidetop=true", { replace: true });
      } else {
        navigate("/booking/hall/select", { replace: true });
      }
    }
  }, [user,location.search]);

  return (
    <div>
      <Modal
        isShow={isDuplicate}
        overlay={true}
        overlayValue={0.5}
        // text={`이미 신청이 완료된 웨딩홀입니다.
				// 추가 요청은 웨딩홀 문의내역에서 말씀해주세요.`}
        text={`동일한 웨딩홀에 방문 예약이 존재합니다.
          예약된 일정을 확인 후 다시 진행해주세요.`}
        buttons={[
          {
            name: "닫기",
            className: "btn-red0",
            action: () => {
              window.location.href = "h2mwbell://webview/close";
              // navigate(`/weddinghall/${partnerUuids}?hidetop=true`, { replace: true });
            },
          },
          {
            name: "예약내역",
            className: "btn-red500",
            action: () => {
              window.location.href= isExternalUrl(`${HOSTNAME}/my-reservation/weddinghall?tab=visit&hidetop=true`);
            },
          },
        ]}
      />
    </div>
  );
};

export default Index;
